import React from 'react'
import { SiEducative } from 'react-icons/si'
import TechnologyServicePage from '../components/TechnologyServicePage'

const capabilities = [
    { title: 'Student Information Systems', description: 'Centralize student records, academic history, and administration.' },
    { title: 'Learning Management', description: 'Deliver courses, materials, assessments, and learner engagement online.' },
    { title: 'School Management', description: 'Manage daily school operations from one reliable platform.' },
    { title: 'University Management', description: 'Support admissions, departments, programmes, and campus workflows.' },
    { title: 'Online Admissions', description: 'Simplify applications, review, approvals, and applicant communication.' },
    { title: 'Student & Parent Portals', description: 'Give families secure access to updates, records, and services.' },
    { title: 'Examination Management', description: 'Organize assessments, grading, results, and exam workflows.' },
    { title: 'Attendance Management', description: 'Track attendance clearly across classes, programmes, and terms.' },
    { title: 'Mobile Learning', description: 'Extend learning through mobile-friendly digital classroom tools.' }
]

const EducationTechnologySolutions = () => (
    <TechnologyServicePage
        badge="Education Technology Solutions"
        title="Digital platforms that make learning and administration easier."
        description="We build education systems for schools and universities, covering learning, admissions, attendance, exams, portals, and digital classrooms."
        metaDescription="Education technology solutions including SIS, LMS, school management, university management, admissions, portals, exams, attendance, and mobile learning."
        icon={<SiEducative className="text-sm" />}
        capabilities={capabilities}
        featuredVisual={{
            image: '/assets/edu.jpg',
            alt: 'VRIFY EDU 360 Schools Integrated Information Management System and its education management modules',
            eyebrow: 'Featured education platform',
            title: 'Meet VRIFY EDU 360.',
            description: 'A connected school information management system that brings essential academic, financial, communication, and reporting tools into one clear digital experience.',
            points: [
                'Student & academic management',
                'Fees, assessments & grades',
                'Parent communication & analytics'
            ]
        }}
        outcomes={[
            { title: 'Simpler administration', description: 'Reduce paperwork and improve access to academic information.' },
            { title: 'Stronger engagement', description: 'Connect students, parents, teachers, and administrators digitally.' },
            { title: 'Flexible learning', description: 'Support digital classrooms and mobile learning experiences.' }
        ]}
        highlights={[
            { title: 'Organize', description: 'Centralize records, admissions, exams, attendance, and operations.' },
            { title: 'Connect', description: 'Give students and parents secure portals for important services.' },
            { title: 'Teach', description: 'Deliver digital learning through LMS, classroom, and mobile tools.' }
        ]}
        cta={{
            eyebrow: 'Education made digital',
            title: 'Create a connected academic experience for every user.',
            description: 'We help institutions modernize administration and learning without adding complexity.'
        }}
    />
)

export default EducationTechnologySolutions
